export default {
  hover: '#F5F5F8',
};
